<template>
  <div class="sideNavVue">
    <div>
      <div v-if="userRoleSlug == 'client-admin' ||
          userRoleSlug == 'power-user' ||
          userRoleSlug == 'power-user-minus' ||
          userRoleSlug == 'employee' ||
          userRoleSlug == 'auditor'"
        class="o-sidenav mainSidenav"
      >
        <div class="o-logo-area">
          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer">
            <img src="static/assets/images/logo.png" />
          </a>

          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer" v-if="client_logo_url!=''&&client_logo_url!='NA'">
            <img class="o-client-logo" :src="client_logo_url" />
          </a>

          <!-- #1694 — when this page was opened FROM the native app (app_source),
               the M button returns to the app, so the label must say so.
               Renders on ALL form factors (the old `v-if="deviceDetector"` hid it on
               desktop UAs — dropped per Ed). On desktop launchedFromApp is false, so
               changeViewDevice() takes its else-branch (in-browser mobile schedule view)
               and mButtonLabel reads "MobileView" — no native-app hop on desktop. -->
          <el-tooltip :content="mButtonLabel" placement="right" effect="dark">
            <span>
              <a
                href="javascript: void(0)"
                class="o-mainlogo"
              >
                <button
                  class="view-change-button"
                  :title="mButtonLabel"
                  :aria-label="mButtonLabel"
                  @click="changeViewDevice()"
                >
                  M
                </button>
              </a>
            </span>
          </el-tooltip>
        </div>
        <ul class="o-sidebar-menu o-sidebar-bg sidebar">

          <li
            v-if="
              getPower('jobEvent') &&
              (((isSteward == 1 || isDispatcher == 1) && userRoleSlug == 'employee') ||
                userRoleSlug != 'employee') && isFrelenceUser()" @click="goToJobList()"
          >
            <el-tooltip content="JobsEvents" placement="right" effect="dark">
              <span>
                <router-link to="/jobList">
                    <span class="o-sidemenu-icon"
                        ><i class="fa fa-briefcase" aria-hidden="true"></i
                      ></span>
                      {{ $t("jobs_events") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="userRoleSlug=='client-admin'||userRoleSlug=='power-user'||userRoleSlug=='power-user-minus'"
            @click="goToEmployee911Availability()">
            <el-tooltip content="911Availability" placement="right" effect="dark">
              <span>
                <router-link to="/911-availability">
                  <span class="o-sidemenu-icon"
                    ><i class="fa fa-clock-o" aria-hidden="true"></i></span
                  >911 Availability
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li
            v-if="getPower('schedule') && isFrelenceUser()"
            @click="goToScedule()"
          >
            <el-tooltip content="Schedule" placement="right" effect="dark">
              <span>
                <router-link
                  :to="{ name: 'Schedule', params: { empId: this.encodedEmpId } }"
                  ><span class="o-sidemenu-icon">
                    <i class="fa fa-list-ol" aria-hidden="true"></i>
                  </span>
                  {{ $t("schedule") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li
            v-if="getPower('calender') && isFrelenceUser()"
            @click="goToCalendar()"
          >
            <el-tooltip content="Calendar" placement="right" effect="dark">
              <span>
                <router-link to="/calendar">
                  <span class="o-sidemenu-icon"
                    ><i class="fa fa-calendar" aria-hidden="true"></i></span
                  >{{ $t("calendar") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('resume')" @click="goToResume()">
            <el-tooltip content="Resume" placement="right" effect="dark">
              <span>
                <router-link to="/resume">
                  <span class="o-sidemenu-icon">
                    <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                  </span>
                  {{ $t("resume") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li
            v-if="getPower('employer') && isFrelenceUser()"
            @click="goToEmployers()"
          >
            <el-tooltip content="Employer" placement="right" effect="dark">
              <span>
                <router-link to="/employerList"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-user" aria-hidden="true"></i></span
                  >{{ $t("employers") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <!-- #1697 — Payroll re-added, wired to the WORKING FlexSheet form
               (/payroll — client-side entry reading #1702 client_employer_payroll).
               The OLD inert payroll menu (router-link to="", dead payrolls tables)
               was removed 2026-08-17; this is the new surface. Gated to PU / CA / EA
               (power-user, client-admin, employer-admin) per Ed. -->
          <li
            v-if="userRoleSlug=='power-user' || userRoleSlug=='client-admin' || userRoleSlug=='employer-admin'"
            @click="goToPayroll()"
          >
            <el-tooltip content="Payroll" placement="right" effect="dark">
              <span>
                <router-link to="/payroll"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-usd" aria-hidden="true"></i></span
                  >Payroll
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('venue')" @click="goToVenue()">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <span>
                <router-link to="/venue"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-map-marker" aria-hidden="true"></i
                  ></span>
                  {{ $t("venue") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('employees')" @click="goToEmployees()">
            <el-tooltip content="Employees" placement="right" effect="dark">
              <span>
                <router-link to="/employees"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-users" aria-hidden="true"></i></span
                  >{{ $t("employees") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <!-- Onboard: shown ONLY to users explicitly granted access in a
               template's User-Access list (has_explicit_access). The Onb.
               Profiles management item was removed from the menu; that screen
               is still reachable at /onboarding/profiles by URL. -->
          <li v-if="hasAssignedProfiles">
            <el-tooltip content="Send Onboarding Link" placement="right" effect="dark">
              <span>
                <router-link to="/onboarding/send"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-paper-plane-o" aria-hidden="true"></i></span
                  >Onboard</router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('dailySchedule')" @click="goToDailySchedule()">
            <el-tooltip content="DailySchedule" placement="right" effect="dark">
              <span>
                <router-link to="/dailySchedule"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-calendar-plus-o" aria-hidden="true"></i></span
                  >{{ $t("daily_schedule") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('skills')" @click="goToSkills()">
            <el-tooltip content="Skills" placement="right" effect="dark">
              <span>
                <router-link to="/skills"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-wrench" aria-hidden="true"></i
                  ></span>
                  {{ $t("skills") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('files')" @click="goToFiles()">
            <el-tooltip content="Files" placement="right" effect="dark">
              <span>
                <router-link to="/files"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-folder" aria-hidden="true"></i
                  ></span>
                  {{ $t("files") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li v-if="(getPower('drive') || hasDriveAccess) && (userRoleSlug != 'employee' || (clientData && !clientData.hide_drive_basic_user))" @click="goToDrive()">
            <el-tooltip content="Drive" placement="right" effect="dark">
              <router-link to="/drive"
                ><span class="o-sidemenu-icon"
                  ><i class="fa fa-cloud" aria-hidden="true"></i
                ></span>
                Drive</router-link
              >
            </el-tooltip>
          </li>

          <!-- <li v-if="getPower('report') && isFrelenceUser()" @click="goToReport()"><router-link to="/reportList"><span class="o-sidemenu-icon"><i class="fa fa-file-o" aria-hidden="true"></i></span> Report</router-link></li> -->
          <li
            v-if="getPower('report') && isFrelenceUser()"
            @click="goToReport()"
          >
            <el-tooltip content="Reports" placement="right" effect="dark">
              <span>
                <router-link to="/report-list"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-file-o" aria-hidden="true"></i></span
                  >{{ $t("report") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li
            v-if="
              getPower('notify') &&
              ((isSteward == 1 && userRoleSlug == 'employee') ||
                userRoleSlug != 'employee')
            "
            @click="goToNotify()"
          >
            <el-tooltip content="Notify" placement="right" effect="dark">
              <span>
                <router-link to="/notify"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-commenting-o" aria-hidden="true"></i></span
                  >{{ $t("notify") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('support')">
            <el-tooltip content="Support" placement="right" effect="dark">
              <span>
                <a
                  :href="support_site_url"
                  target="_blank"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-life-ring" aria-hidden="true"></i></span
                  >{{ $t("support") }}
                </a>
              </span>
            </el-tooltip>
          </li>

          <li v-if="getPower('status-icon')">
            <el-tooltip content="Status" placement="right" effect="dark">
              <span>
                <a href="https://callsteward.freshstatus.io/" target="_blank"
                  ><span class="o-sidemenu-icon"
                    ><i
                      class="fa fa-exclamation-triangle"
                      aria-hidden="true"
                    ></i></span
                  >{{ $t("status") }}</a
                >
              </span>
            </el-tooltip>
          </li>

          <li v-if="userRoleSlug=='client-admin' || billing_employee"
            @click="goToInvoices()">
            <el-tooltip content="Invoice" placement="right" effect="dark">
              <span>
                <router-link to="/cs-invoices"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-dollar" aria-hidden="true"></i></span
                  >CS Invoices
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="isSplashEditor && userRoleSlug!='client-admin'">
            <el-tooltip content="Splash Page" placement="right" effect="dark">
              <span>
                <router-link to="/splash-page"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-paint-brush" aria-hidden="true"></i></span
                  >Splash Page
                </router-link>
              </span>
            </el-tooltip>
          </li>
        </ul>
        <div class="branch-label">{{ instanceName }}</div>
      </div>

      <div v-else class="o-sidenav mainSidenav">
        <div class="o-logo-area">
          <a href="javascript: void(0)" class="o-mainlogo img-class-pointer"
            ><img src="static/assets/images/logo.png"
          /></a>
        </div>
        <ul class="o-sidebar-menu o-sidebar-bg">
          <li @click="goToJobList()">
            <el-tooltip content="JobsEvents" placement="right" effect="dark">
              <span>
                <router-link to="/jobList"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-briefcase" aria-hidden="true"></i
                  ></span>
                  {{ $t("jobs_events") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li>
            <el-tooltip content="EmployerCalendar" placement="right" effect="dark">
              <span>
                <router-link to="/calendarEmployer">
                  <span class="o-sidemenu-icon"
                    ><i class="fa fa-calendar" aria-hidden="true"></i
                    ></span>
                  {{ $t("calendar") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li @click="goToResumeEmployer()">
            <el-tooltip content="EmployerResume" placement="right" effect="dark">
              <span>
                <router-link to="/resume"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-graduation-cap" aria-hidden="true"></i></span
                  >{{ $t("resume") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li v-if="userRoleSlug == 'employer-admin'">
            <el-tooltip content="EmployerUser" placement="right" effect="dark">
              <span>
                <router-link to="/employerUserList"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-users" aria-hidden="true"></i
                  ></span>
                  {{ $t("group_users") }}</router-link
                >
              </span>
            </el-tooltip>
          </li>

          <li @click="goToVenue()" v-if="getPower('venue')">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <span>
                <router-link to="/venue">
                  <span class="o-sidemenu-icon">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </span>
                  {{ $t("venue") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li @click="goToVenue()" v-else-if="userRoleSlug=='employer-admin' || userRoleSlug=='employer'">
            <el-tooltip content="Venue" placement="right" effect="dark">
              <span>
                <router-link to="/venue">
                  <span class="o-sidemenu-icon">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                  </span>
                  {{ $t("venue") }}
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <!-- #1715 — Company Users. employerUserList / addEmployerUser have always
               been in employerAdminRoute, so an employer admin was permitted to use
               them, but NOTHING in the live UI linked there: the only links were in
               forceLogin.vue and sideNav_old.vue, which is not the sidenav in use
               (App.vue imports ./components/sideNav). So the pages existed and were
               allowed and simply could not be reached. -->
          <li v-if="userRoleSlug=='employer-admin'">
            <el-tooltip content="Company Users" placement="right" effect="dark">
              <span>
                <router-link to="/employerUserList">
                  <span class="o-sidemenu-icon">
                    <i class="fa fa-users" aria-hidden="true"></i>
                  </span>
                  Company Users
                </router-link>
              </span>
            </el-tooltip>
          </li>

          <li>
            <el-tooltip content="Support" placement="right" effect="dark">
              <span>
                <a
                  :href="support_site_url"
                  target="_blank"
                  ><span class="o-sidemenu-icon"
                    ><i class="fa fa-life-ring" aria-hidden="true"></i
                  ></span>
                  {{ $t("support") }}</a
                >
              </span>
            </el-tooltip>
          </li>
        </ul>
        <div class="branch-label">{{ instanceName }}</div>
      </div>

      <span
        class="o-sidebar-trigger js-sidebarTrigger" title="Triggers"
        @click="headerTrigger($event)"
        ><i class="fa fa-bars" aria-hidden="true"></i
      ></span>
    </div>
  </div>
</template>

<script>
import dateTimeConvert from "../timeConvert&Compare";
import { mapGetters, mapActions } from "vuex";
import service from "../services.js";
import i18n from "@/lang/i18n";
import { getReturnToAppUrl } from "../global.js";   // #1694

export default {
  data() {
    return {
      windowWidth: "",
      encodedEmpId: btoa(this.employeeId),
      isSteward: 0,
      isDispatcher: 0,
      hideMobileSwitch: true,
      client_logo_url: '',
      billing_employee: false,
      isSplashEditor: false,
      support_site_url: 'http://support.callsteward.com/support/home',
      power_steward_enabled: 0,
      clientData: null,
      hasDriveAccess: false,
      instanceName: '',
      // #1481 — true when the current user has at least one onboarding
      // preset granted via profile_user_access. Populated in created()
      // from `onboarding/my-profiles`; used to surface the "Onboard" menu
      // item to assigned non-admin users without granting them the full
      // employees-power permission.
      hasAssignedProfiles: false,
    };
  },
  computed: {
    ...mapGetters({
      userToken: "userToken",
      userRole: "userRole",
      userClientID: "userClientID",
      subDomain: "getSubdomain",
      employeeId: "employeeId",
      userRoleSlug: "userRoleSlug",
      userEmail: 'userEmail',
      isBillingEmployee: 'isBillingEmployee',
      queryParamClientId: 'queryParamClientId',
      queryParamAppSource: 'queryParamAppSource'
    }),
    /**
     * #1694 — was this desktop page opened FROM the native app?
     *
     * The app's D switch opens the magic-link desktop URL in the external browser with
     * `&app_source=true`, and magicLink.vue persists it into localStorage.queryParams
     * (the store copy does NOT survive, because getting here is a full page load).
     * localStorage is therefore the source of truth; the Vuex getter is only a
     * same-load fast path.
     *
     * NB `localStorage.setItem('queryParams', null)` stores the STRING "null", which
     * JSON.parse turns back into null — hence the null check rather than a bare parse.
     */
    launchedFromApp() {
      if (this.queryParamAppSource) {
        return true;
      }
      try {
        const queryParams = JSON.parse(localStorage.getItem('queryParams'));
        return !!(queryParams && queryParams.app_source);
      } catch (e) {
        return false;
      }
    },
    mButtonLabel() {
      return this.launchedFromApp ? 'Return to App' : 'MobileView';
    },
    deviceDetector() {
        let userAgent = navigator.userAgent.toLowerCase();
        const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
        return("desktop" != check ? !0 : !1);
    },
  },
  methods: {
    fetchInstanceName() {
      service.get('server-info', {}).then((res) => {
        if (res && res.data && res.data.instance_name) {
          this.instanceName = res.data.instance_name;
        }
      }).catch(() => {});
    },
    // #1481 — surface the Onboard menu item to non-admin users who have
    // been assigned at least one onboarding preset via profile_user_access.
    // The endpoint is safe to call for any role; admins see their normal
    // full set, assigned non-admins see their granted subset. Failure is
    // swallowed — menu just stays hidden, matches pre-change behavior.
    checkAssignedOnboardingProfiles() {
      // The whole onboarding feature lives on /api/v3 — every other caller uses
      // service.getUrl('/api/v3/onboarding/...'). A bare service.get() resolves
      // against the default /api/v2 base, which has no onboarding routes, so the
      // request fell through to the SPA catch-all and returned index.html (200).
      // res.data was then an HTML string, has_explicit_access was undefined, and
      // the Onboard menu stayed hidden for granted stewards. Call v3 explicitly;
      // the api interceptor injects Authorization, so no header arg is needed.
      service.getUrl('/api/v3/onboarding/my-profiles').then((res) => {
        // Gate strictly on explicit template access — the API returns
        // has_explicit_access=true only when the user is granted access in a
        // template's User-Access list (the fallback "all profiles" window
        // returns false here, so Onboard stays hidden for non-granted users).
        this.hasAssignedProfiles = !!(res && res.data && res.data.has_explicit_access);
      }).catch(() => {
        this.hasAssignedProfiles = false;
      });
    },
    async getClientData() {
      if(this.userRoleSlug != 'employer-admin' ) {
        await service.get('client/' + this.userClientID, {
        'Authorization': this.userToken
        })
        .then((res) => {
          this.clientData = res.data.result;
          let billing_email = this.clientData.billing_email;
          this.support_site_url = this.clientData.support_site_url && this.clientData.support_site_url != '' ? this.clientData.support_site_url : 'http://support.callsteward.com/support/home';
          this.billing_employee = this.userEmail==billing_email?true:false;
          this.power_steward_enabled = this.clientData.power_steward;
          this.$store.dispatch('setIsBillingEmployee', this.billing_employee);
          this.client_logo_url = this.clientData.logo;
          // Check if current user is a splash page editor
          var splashEditors = this.clientData.settings && this.clientData.settings['splash-editors'] ? this.clientData.settings['splash-editors'] : [];
          this.isSplashEditor = splashEditors.indexOf(this.employeeId) !== -1
        }).catch((err) => {
            console.log(err);
        });
      }
    },
    async changeViewDevice() {
      // #1694 — two different jobs behind one button.
      //
      // Opened FROM the app: bring the backgrounded APK back to the foreground via the
      // verified Android App Link `/open/mobile`. The App Link intercepts /open/*
      // before the browser can render it, so nothing loads in the browser and the
      // native app receives the deep link in _handleDeepLink().
      //
      // The target is deliberately NOT window.location.origin. Only three hosts are
      // App-Link-verified for com.callsteward.mobile (stage-callsteward.com,
      // admin.callsteward.com/.ca) and the desktop web app runs on none of them — it
      // runs on `login.` and tenant subdomains. On-device,
      // login.stage-callsteward.com/open/mobile just opens Chrome. getReturnToAppUrl()
      // maps the current environment to its verified host and we go cross-origin.
      //
      // This also replaces a hop through `https://cs3.me/confirm2` — a YOURLS short
      // link on the NOTIFY box that redirects to login.callsteward.com, i.e. a STAGE
      // session was being bounced to PRODUCTION. The old path further required a
      // non-empty client_id, so an app-launched session without one silently fell
      // through to the schedule route instead of returning.
      if (this.launchedFromApp) {
        const returnUrl = getReturnToAppUrl();
        if (returnUrl) {
          // #1708 — mint a short-lived (120s) single-use swap token bound to THIS
          // authenticated web session, and append it so the native app adopts the
          // session instead of foregrounding unauthenticated. The App Link (Android)
          // and the /open/mobile interstitial → callsteward:// (iOS) both carry the
          // params; the app POSTs {email,token} to auth/magic-link/swapMagicLinkToken.
          try {
            const res = await service.post('auth/open-app-token', {}, {
              'Authorization': this.userToken,
              'cs3-context-role': this.userRole,
              'cs3-context-clientId': this.userClientID,
            });
            const r = (res && res.data && res.data.result) || {};
            if (r.email && r.token) {
              const sep = returnUrl.indexOf('?') === -1 ? '?' : '&';
              window.location.href = returnUrl + sep + 'email=' + encodeURIComponent(r.email) + '&token=' + encodeURIComponent(r.token);
              return;
            }
          } catch (e) {
            console.log('[#1708] mint app-return token failed; foregrounding without session:', e);
          }
          // Fallback (mint failed): foreground the app unauthenticated (pre-#1708 behavior).
          window.location.href = returnUrl;
          return;
        }
        // Unrecognised host (preview box / localhost): fall through to the in-browser
        // view rather than navigate somewhere that would 404 or cross environments.
        console.warn('[#1694] no verified App Link host for ' + window.location.hostname);
      }

      // Plain web user: unchanged — the in-browser mobile schedule view.
      window.location.href = window.location.href.split("#")[0] + "#/schedule/" + btoa(this.employeeId);
    },
    checkSteward() {
      this.isSteward = null;
      service
        .get("employee/" + this.employeeId + "/checkSkill", {
          Authorization: this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        })
        .then((res) => {
          this.isSteward = res.data.result;
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    checkDispatcher() {
      this.isDispatcher = null;
      service
        .get("employee/" + this.employeeId + "/checkDispatchBySkill", {
          Authorization: this.userToken,
          "cs3-context-role": this.userRole,
          "cs3-context-clientId": this.userClientID,
        })
        .then((res) => {
          this.isDispatcher = res.data.result;
          this.$forceUpdate();
        })
        .catch(() => {});
    },
    getPower(data) {
      return dateTimeConvert.checkAccess(data);
    },
    isFrelenceUser() {
      return dateTimeConvert.disabledFrelenceUser();
    },
    goToJobList() {
      this.$router.push({ path: "/jobList" }).catch(() => {});
    },
    goToCalls() {
      this.$router.push({ path: "/callList11" }).catch(() => {});
    },
    goToScedule() {
      this.$router.push({ path: "/schedule/" + btoa(this.employeeId) }).catch(() => {});
    },
    goToEmployers() {
      this.$router.push({ path: "/employerList" }).catch(() => {});
    },
    goToPayroll() { // #1697
      this.$router.push({ path: "/payroll" }).catch(() => {});
    },
    goToEmployees() {
      this.$router.push({ path: "/employees" }).catch(() => {});
    },
    goToDailySchedule() {
      this.$router.push({ path: "/dailySchedule" }).catch(() => {});
    },
    goToSkills() {
      this.$router.push({ path: "/skills" }).catch(() => {});
    },
    goToFiles() {
      this.$router.push({ path: "/files" }).catch(() => {});
    },
    goToDrive() {
      this.$router.push({
        path: "/drive",
      });
    },
    goToNotify() {
      this.$router.push({ path: "/notify" }).catch(() => {});
    },
    goToInvoices() {
      this.$router.push({ path: "/cs-invoices" }).catch(() => {});
    },
    goToEmployee911Availability() {
      this.$router.push({ path: "/911-availability" }).catch(() => {});
    },
    goToVenue() {
      this.$router.push({ path: "/venue" }).catch(() => {});
    },
    goToReport() {
      this.$router.push({ path: "/report-list" }).catch(() => {});
    },
    goToCalendar() {
      this.$router.push({ path: "/calendar" }).catch(() => {});
    },
    goToResume() {
      this.$router.push({ path: "/resume" }).catch(() => {});
    },
    goToResumeEmployer() {
      let url = "https://resume.callsteward.com";
      window.open(url, "_blank");
    },
    async checkDriveAccess() {
      try {
        let res = await service.get('drive/check-access', {
          'Authorization': this.userToken,
          'cs3-context-clientId': this.userClientID,
          'cs3-context-employeeId': this.employeeId,
          'cs3-context-role': this.userRole
        });
        this.hasDriveAccess = res.data.has_access || false;
      } catch (e) {
        this.hasDriveAccess = false;
      }
    },
    headerTrigger(event=null) {
      this.windowWidth = $(window).width();
      const sidenavWidth = $(".mainSidenav").width();
      if (this.windowWidth > 1080) {
        if ($(".mainSidenav").hasClass("open")) {
          $(".mainSidenav").css("width", "60px").removeClass("open");
          $(".wrapper").css("margin-left", "60px");
          $(".o-sidebar-trigger").css("left", "75px");
          $(".o-header").css("width", $(".o-header").width() + 160 + "px");
          $(".o-sidebar-trigger")
            .children()
            .removeClass("fa-arrows-alt")
            .addClass("fa-bars");
          $(".o-sidebar-bg li a").attr("data-toggle", "popover");
          $('[data-toggle="popover"]').popover();
          $(".mainSidenav .o-client-logo").css("margin", '0');
          $(".mainSidenav .o-client-logo").css("margin-top", "10px");
        } else {
          $(".mainSidenav").css("width", "220px").addClass("open");
          $(".o-header").css("width", $(".o-header").width() - 160 + "px");
          $(".wrapper").css("margin-left", "220px");
          $(".o-sidebar-trigger").css("left", "230px");
          $(".o-sidebar-trigger")
            .children()
            .removeClass("fa-bars")
            .addClass("fa-arrows-alt");
          $(".o-sidebar-bg li a").removeAttr("data-toggle", "popover");
          $(".o-client-logo").css("margin", '0');
          $(".o-client-logo").css("margin-left", "50px");
        }
      }
    },
  },
  mounted() {
    if (this.windowWidth > 1366) {
      $(".mainSidenav").css("width", "220px").addClass("open");
      $(".mainSidenav .o-client-logo").css("margin", '0');
      $(".mainSidenav .o-client-logo").css("margin-top", "10px");
      $(".wrapper").css("margin-left", "220px");
      $(".js-sidebarTrigger")
        .children()
        .removeClass("fa-bars")
        .addClass("fa-arrows-alt");
      $(".o-header").css("width", this.windowWidth - 220);
      $(".js-sidebarTrigger").css("left", "230px");
    }
  },
  async created() {
    await this.getClientData();
    if (this.userRoleSlug == "employee") {
      this.checkSteward();
      this.checkDispatcher();
      this.checkDriveAccess();
    }
    this.windowWidth = $(window).width();
    this.encodedEmpId = btoa(this.employeeId);
    this.fetchInstanceName();
    this.checkAssignedOnboardingProfiles();
  }
};
</script>

<style scoped>
.o-client-logo{
  width: 55px!important;
}
.margin-left-50 {
  margin-left: 50px!important;
}
.margin-top-10 {
  margin-top: 10px!important;
}
.view-change-button {
  margin-top: 5px;
  margin-left: 10px;
  height: 35px;
  width: 35px;
  color: #000000;
  background-color: #06a865;
  float: right;
  font-size: 25px;
  font-weight: bold;
  border: none;
}
.item {
  cursor: pointer;
}
.img-class-pointer {
  cursor: auto;
}
.sidebar {
  overflow: auto;
  max-height: 92%;
  overflow-x: hidden;
  height: auto;
  overflow-y: scroll;
}
.sidebar::-webkit-scrollbar {
  display: none;
}
.sidebar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
.o-sidemenu-icon {
  margin-right: 5px;
}
.branch-label {
  position: absolute;
  bottom: 4px;
  left: 0;
  width: 100%;
  text-align: center;
  font-size: 9px;
  color: #ffffff;
  pointer-events: none;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 4px;
}
</style>
